import type { FunctionComponent } from 'react';
import type { TypeColumn } from './types';

export const Column: FunctionComponent<TypeColumn> = ({
  as: HtmlTag = 'div',
  className,
  style,
  children,
}: TypeColumn) => (
  <HtmlTag className={`w-full ${className}`} style={style}>
    {children}
  </HtmlTag>
);
